import { render, staticRenderFns } from "./WizardNavigation.vue?vue&type=template&id=ffd655da"
import script from "./WizardNavigation.vue?vue&type=script&lang=ts"
export * from "./WizardNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports